import './ReviewSec.scss';
import Component from './ReviewSec.js';
export default Component;
